// eslint-disable-next-line vue/no-parsing-error

const BaseURL = "http://ad.midongtech.com/api/";

const md5key = "mOIryqPUrnI6hDZq";

class Tools {
  constructor() {
    // this.baseRequestUrl = Config.restUrl;
  }

  // JS控制只能输入数字并且最多允许小数点两位
  clearNoNum(e) {
    e.detail.value = e.detail.value.replace(/[^\d.]/g, ""); // 清除“数字”和“.”以外的字符
    e.detail.value = e.detail.value.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
    e.detail.value = e.detail.value
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");
    e.detail.value = e.detail.value.replace(
      // eslint-disable-next-line no-useless-escape
      /^(\-)*(\d+)\.(\d\d).*$/,
      "$1$2.$3"
    ); // 只能输入两个小数
    if (e.detail.value.indexOf(".") < 0 && e.detail.value != "") {
      // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
      e.detail.value = parseFloat(e.detail.value);
    }
  }
  // 判断是否为空
  judgeNull(value) {
    if (value == null || value == undefined) return true;
    if (this.judgeString(value)) {
      if (value.trim().length == 0) return true;
    } else if (this.judgeArray(value)) {
      if (value.length == 0) return true;
    } else if (this.judgeObject(value)) {
      for (let name in value) return false;
      return true;
    }
    return false;
  }
  // 判断是否为字符串
  judgeString(value) {
    return value != null && value != undefined && value.constructor == String;
  }
  // 判断是否为数字
  judgeNumber(value) {
    return value != null && value != undefined && value.constructor == Number;
  }
  // 判断是否为Bool
  judgeBoolean(value) {
    return value != null && value != undefined && value.constructor == Boolean;
  }
  // 判断是否为数组
  judgeArray(value) {
    return value != null && value != undefined && value.constructor == Array;
  }
  // 判断是否为集合元素
  judgeObject(value) {
    return value != null && value != undefined && value.constructor == Object;
  }
  // 判断是否为方法
  judgeFunction(value) {
    return value != null && value != undefined && value.constructor == Function;
  }

  // 去除字符串空格
  Removewhitespace(value) {
    let resultstr = "";
    if (!this.judgeNull(value)) {
      resultstr = value.replace(/\s+/g, "");
    }
    return resultstr;
  }

  //随机数组中随机取几个元素
  //var items = ['1','2','4','5','6','7','8','9','10'];
  // console.log( getRandomArrayElements(items, 4) );
  getRandomArrayElements(arr, count) {
    let shuffled = arr.slice(0),
      i = arr.length,
      min = i - count,
      temp,
      index;
    while (i-- > min) {
      index = Math.floor((i + 1) * Math.random());
      temp = shuffled[index];
      shuffled[index] = shuffled[i];
      shuffled[i] = temp;
    }
    return shuffled.slice(min);
  }

  // 数组聚合  把一个数组 按一定长度比例 切割成几个小元素 并最终合并为一个大数组
  chunk(arr, size) {
    const arr2 = [];
    for (let i = 0; i < arr.length; i = i + size) {
      let xiao = arr.slice(i, i + size);
      arr2.push(xiao);
    }
    return arr2;
  }

  //跳转外部链接 要注意, 要加上 http:// ,  不然跳转还是当前域名下
  //例如 window.location.href = 'http://www.baidu.com';
  jumptowebsite(websitestr) {
    window.location.href = websitestr;
  }

  // 获取当前时间(YYYY-mm-dd)
  getNowFormatDate() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + "-" + month + "-" + strDate;
    return currentdate;
  }

  getBaseURL() {
    return BaseURL;
  }

  getmd5key() {
    return md5key;
  }
}

export default new Tools();
